/**
 * Round 29: the website names itself on every generated-client request, so
 * the server enforces the Round 28 checklist categories for it (the website
 * has that checklist). Builds of the website from before Round 28 don't send
 * it, and the server treats them like an older app build.
 */
export const WEB_CLIENT_HEADERS: Readonly<Record<string, string>> = { "x-app-platform": "web" };
